module.exports = __webpack_public_path__ + "img/16l003-09.6a372843.jpg";